module.exports = __webpack_public_path__ + "img/discard-data.c4910622.png";